import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
    selector: 'footer-bar',
    template: require('./footer-bar.component.html'),
    styles: [require('./footer-bar.component.css')]
})

export class FooterBarComponent {
    constructor(){
    }

    ngOnInit(){
        (<any>$('#SponsorFooter .carousel')).carousel({
            interval: 4000,
            keyboard: true,
            pause: 'hover',
            wrap: true
        });
        
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/footer-bar/footer-bar.components.ts